import { environment } from '../environments/environment';

/**
 * The self-service platform API base: `SELF_SERVICE_API_BASE_URL` when the
 * environment sets it, else `URL`. A bare host ("https://dev-im.alpha.simadvisory.com")
 * gets the `/spriced/platform` prefix the API paths are relative to.
 */
export function selfServiceBaseUrl(): string {
  const env = environment as { URL?: string; SELF_SERVICE_API_BASE_URL?: string };
  const configured = String(env.SELF_SERVICE_API_BASE_URL ?? '').trim().replace(/\/+$/, '');
  if (!configured) return String(env.URL ?? '').trim();
  return /\/spriced\/platform$/i.test(configured) ? configured : `${configured}/spriced/platform`;
}
